// @ts-strict-ignore
import React, { CSSProperties, ReactElement, ComponentProps, forwardRef, ForwardedRef, ElementType } from 'react'
import { List, AutoSizer } from 'react-virtualized'
import 'react-virtualized/styles.css'

export interface IRowRendererProps {
  index: number
  key: string
  style: CSSProperties
}

interface IVirtualizedListProps extends Omit<ComponentProps<typeof List>, 'rowCount' | 'width' | 'height' | 'rowRenderer'> {
  rowComponent: ElementType<IRowRendererProps>
  // How tall each element should be forced to be
  rowHeight: number
  count: number
  noRowsRenderer?: () => ReactElement
  // Total height in pixels that the list should occupy
  height?: number
}

const VirtualizedList = ({
  rowComponent: RowComponent,
  rowHeight,
  count,
  height: fixedHeight,
  ...otherProps
}: IVirtualizedListProps, ref: ForwardedRef<HTMLDivElement>) => (
  <AutoSizer disableHeight={Boolean(fixedHeight)}>
    {({ width, height }) => (
      <List
        ref={ref}
        width={width}
        height={fixedHeight || height}
        estimatedRowSize={rowHeight}
        rowHeight={rowHeight}
        rowCount={count}
        rowRenderer={({ index, key, style }: IRowRendererProps) => (
          <RowComponent key={key} index={index} style={style} />
        )}
        {...otherProps}
      />
    )}
  </AutoSizer>
)

export default forwardRef(VirtualizedList)
